module.exports = __webpack_public_path__ + "static/media/tissue_paper_instructions.299ba719.png";